import { createContentPropTypes } from '../../../helpers/content';

const content = {
	toLabel: 'To',
	fromLabel: 'From',
	amountLabel: 'Amount',
	referenceLabel: 'Reference',
	hmrcReferenceLabel: 'HMRC reference',
	transactionCodeLabel: 'Transaction Code',
	totalAmountLabel: 'Total amount',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
